import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-6",
  "use": "icon-icon-nav-6-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-6\"><path d=\"M511.68 160A351.808 351.808 0 0 0 160 512c0 194.304 157.312 352 351.68 352A352.192 352.192 0 0 0 864 512c0-194.304-157.696-352-352.32-352z m149.184 563.2L512 633.472 363.072 723.2l39.488-169.344-131.328-113.664 173.184-14.784L512 265.6l67.584 159.424 173.184 14.784L621.44 553.6l39.424 169.664z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-6.svg
// module id = Q1/q
// module chunks = 3